import React from "react";
import logo from "../images/nz-transport-agency-logo.png";
import styles from "./DriverConsent.module.scss";

const ConsentPageTitle = () => {
  return (
    <div>
      <div className={styles.whiteHeader}>
        <div className="row">
            <div className="col-sm-4 text-left">
            <img src={logo} alt="Logo" />
            </div>
            <div className="col-sm-8 text-right">
            <h1>Consent to access my information in</h1>
            <h1>Driver Check</h1>
            </div>
          </div>
        </div>
        <div className={`section ${styles.sectionGrey}`}>
          <p>Each person who gives consent to their company/organisation to access their information in Driver Check must complete this form. Copy it as many times as you need or print more from <a href="https://www.nzta.govt.nz/form-DC-consent" target="_blank">www.nzta.govt.nz/form-DC-consent</a></p>
          <p>Please carefully read the information over the page about giving your consent before you sign this form.</p>
          </div>
        <div>
      </div>
    </div>
  )
}

export default ConsentPageTitle;